
import { useNavigate } from 'react-router-dom';
import avtar from '../assets/webp/avtar.webp';
import CustomButton from './elements/CustomButton/CustomButton';
import React, { useState } from "react";
import { setPersonalDetails } from '../Redux/Slices/counterSlice';
import { useDispatch } from 'react-redux';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import RadioCustom from './elements/radioCustom';
import { gender } from '../constants/formConstants';


export default function OnboardingForm({ userTypes }) {
  const [formData, setFormData] = useState({
    gender: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

 const isValidEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};


const isFormComplete =
  formData.firstName.trim() !== '' &&
  formData.lastName.trim() !== '' &&
  isValidEmail(formData.email) &&
   formData.phone.trim() !== '' &&
  formData.gender.trim() !== '';

  const handleSubmit = () => {
    const personalDetails = {
      fullName: formData.firstName + " " + formData.lastName,
      mobile: formData.phone,
      email: formData.email,
      birthDate: null,
      gender: formData.gender,
      addressLine1: "",
      landmark: "",
      city: "",
      state: "",
      zip: "",
      profileImage: null,
      coordinates: null,
    }

    dispatch(setPersonalDetails(personalDetails));
    navigate('/auth/account?role=' + encodeURIComponent(userTypes), { replace: true });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const updateField = (field, val) => {
    setFormData((prev) => ({ ...prev, [field]: val?.target?.value ?? val }));
  }
  return (
    <div className="max-w-lg lgx:max-w-xl bg-white rounded-2xl shadow-lg p-4 md:p-6 lg:p-10">
      <div className="space-y-4">
        <div className="grid grid-cols-1 lg:grid-cols-2  gap-4">
          <input
            type="text"
            name="firstName"
            placeholder="First name"
            value={formData.firstName}
            onChange={handleChange}
            className="w-full  rounded-lg bg-[#F5F8FA] px-3 py-3 lgs:py-5 text-gray-800 placeholder-gray-500 outline-none border-none"
          />
          <input
            type="text"
            name="lastName"
            placeholder="Last name"
            value={formData.lastName}
            onChange={handleChange}
            className="w-full rounded-lg bg-[#F5F8FA] px-3 py-3 lgs:py-5 text-gray-800 placeholder-gray-500 outline-none border-none"
          />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <input
            type="email"
            name="email"
            placeholder="Your email"
            value={formData.email}
            onChange={handleChange}
            required
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
            title="Please enter a valid email address"
            className="w-full rounded-lg bg-[#F5F8FA] px-3 py-3 lgs:py-5 text-gray-800 placeholder-gray-500 outline-none border-none"
          />

          <div>
            <PhoneInput
              name="phone"
              country={"us"}
              value={formData.phone}
              onChange={(e) => updateField('phone', e)}
              inputClass="!w-full !h-[47px] lgs:!h-[63px]  !bg-[#F5F8FA] text-gray-800 !outline-none !border-none !pr-3"
              containerClass="w-full"
              buttonClass="!bg-transparent !border-none"
            />

          </div>
        </div>
        <FormControl
          component="fieldset"
          className="w-full mt-2"
        >
          <div className="font-medium text-gray-600">Gender</div>
          <RadioGroup
            row
            value={formData.gender}
            onChange={(e) => updateField('gender', e)}
          >
            {gender.map((g) => (
              <FormControlLabel
                key={g}
                value={g}
                control={<RadioCustom />}
                label={g[0].toUpperCase() + g.slice(1)}
              />
            ))}
          </RadioGroup>
        </FormControl>


        {/* Action row */}
        <div className="flex flex-col lgs:flex-row  mt-6 gap-4">
           <div className=' w-[150px]'>
              <CustomButton
            onClick={() => handleSubmit()}
            disabled={!isFormComplete}
            customeClass={`auth-button w-[150px] h-[50px] ${isFormComplete ? '' : 'opacity-60 cursor-not-allowed'
              }`}
          >
            Get Started
          </CustomButton>
           </div>
          <div className="flex items-center gap-3">
            <img
              src={avtar}
              alt="Team member"
              className="w-8 h-8 rounded-full border"
            />
            <span className="text-xs text-gray-700">
              Your growth journey starts with just click.
            </span>
          </div>
        </div>
      </div>
    </div>

  );
}